export const data = {
    music: {
        file: new Audio(require("@/assets/audios/mmusic.mp3")), 
        play: false, 
    }, 

    modals: {
        infoModal: false,
    },

    game: {
        running: false
    }
}